import { CompassCardUI } from '@scale/compass-ui/types';
import {
  SnowflakeSqlCardShared,
  type SnowflakeSqlSchemaType,
  type SnowflakeSqlContext,
  SNOWFLAKE_SQL,
} from '@scale/genai-compass-shared/cards/snowflake_sql';
import { faDatabase } from '@fortawesome/pro-solid-svg-icons';
import SnowflakeCardComponent from 'react-scale/corp/views/DataCompassCardsV2/adapter/SnowflakeSqlCard/SnowflakeCardComponent';

const defaultContext: SnowflakeSqlContext = {
  cardType: SNOWFLAKE_SQL,
  code: '',
};

export const SnowflakeSqlCardInfo: CompassCardUI<SnowflakeSqlSchemaType> = {
  ...SnowflakeSqlCardShared,
  title: 'Snowflake SQL Query',
  icon: 'snowflake',
  toolTip: 'Run a Snowflake SQL query to retrieve data for your data analysis.',
  defaultContext,
  button: {
    title: 'SQL',
    icon: faDatabase,
  },
  legacyComponent: SnowflakeCardComponent,
};
